module.exports = __webpack_public_path__ + "img/850x478_Klassisk-carbonara-98003715.275259b4.jpg";